export default "__VITE_ASSET__cc8caa37__"